import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { FiscalNacional } from '../address-form/address-form.component';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import {AppConfigService} from '../app-config.service';

export class User {
    constructor(
        public username: string = '',
        public password: string = ''
    ) { }
}

@Injectable({
    providedIn: 'root',
})
export class AddBillingService {

    form: FormGroup;

    private URL = '';
    private userData: User;

    constructor(private http: HttpClient,
                private fb: FormBuilder,
                private configService: AppConfigService
                ) {
        this.URL = this.configService.getConfig().urlOrdersList;
    }

    addBilling(userData: FiscalNacional): Observable<any> {
        const requestData = {
            ...userData,
            companyName: this.configService.getConfig().companyName
        };

        const params = new HttpParams()
            .set('token', localStorage.getItem('token'));

        console.log('AddBilling', requestData);
        return this.http.post(`${this.URL}/addBillingAddress`, requestData, { params }).pipe(
            map(response => {
                console.log('add billing addresss', response);
                return response;
            }),
            catchError(error => {
                console.log('Error en la solicitud:', error);
                return of({
                    error: {
                        errors: [error.message]
                    }
                });
            })
        );
    }

    getBillingAddresses(): Observable<any> {
        console.log('GetBillingAddresses');

        const params = new HttpParams()
            .set('email', localStorage.getItem('userEmail'))
            .set('company', this.configService.getConfig().companyName)
            .set('token', localStorage.getItem('token'));

        console.log(params);

        return this.http.post(`${this.URL}/getListBilling`, null, { params }).pipe(
            map(response => {
                console.log('Respuestas de getListBilling:', response);
                return response;
            }),
            catchError(error => {
                console.log('Error:', error);
                return of(null);
            })
        );
    }

    deleteBillingAddress(formData: any): Observable<any> {
        const requestData = {
            ...formData,
            companyName: this.configService.getConfig().companyName
        };

        const params = new HttpParams()
            .set('token', localStorage.getItem('token'));

        console.log('Delete BillingAddress');
        console.log('FormData:', requestData);

        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const body = JSON.stringify(requestData);

        return this.http.post(`${this.URL}/deleteBillingAddress`, requestData, { params }).pipe(
            map(response => {
                console.log('Respuestas del servidor:', response);
            }),
            catchError(error => {
                console.error('Error al eliminar datos:', error);
                // Verificar detalles del error
                if (error.status === 400) {
                    console.error('Bad Request', error.error);
                } else if (error.status === 500) {
                    console.error('Error del servidor', error.message);
                }
                return of(null);
            })
        );
    }
}
